import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconSizeTokens, SizeTypeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import React, { memo, useState } from 'react';
import { ActivityIndicator, Pressable, StyleSheet, View, } from 'react-native';
import Typography from '../typography/Typography';
import { Icon } from "../icon/Icon";
import { Space } from "../space/Space";
import { isFromTDLPlatform } from '../pages/utils';
/**
 * Raw Component with Derived props + Theme
 */
const ButtonBaseDLS = ({ id, sizeDLS, loading, typeDLS, label, onPress, iconName, isDisabled, newArchButton = true, paddingHorizontalDC = 32, }) => {
    /**
     * use type, size, buttonThemePros, colorMapping to full customise base component
     * */
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [isFocus, setIsFocus] = useState(false);
    const isfromTDL = isFromTDLPlatform();
    const typeDLSStyles = (_typeDLS) => {
        switch (_typeDLS) {
            case ButtonTypeDLS.PRIMARY:
                return StyleSheet.create({
                    buttonTypeStyleDefault: {
                        backgroundColor: colorMapping[ColorTokens.Primary_100]
                    },
                    buttonTextStyleDefault: {
                        color: '#FFF'
                    },
                    buttonTypeStyleHover: {
                        // backgroundColor: '#122FB7',
                        backgroundColor: colorMapping[ColorTokens.Primary_100]
                    },
                    buttonTextStyleHover: {
                        color: '#FFF'
                    },
                    buttonTypeStyleDisabled: {
                        backgroundColor: '#F9FAFB',
                        borderWidth: 1,
                        borderColor: '#E4E7EC',
                    },
                    buttonTextStyleDisabled: {
                        color: '#667085',
                    },
                });
            case ButtonTypeDLS.SECONDARY:
                return StyleSheet.create({
                    buttonTypeStyleDefault: {
                        borderWidth: 1,
                        borderColor: colorMapping[ColorTokens.Primary_100],
                        backgroundColor: '#FFF',
                    },
                    buttonTextStyleDefault: {
                        color: '#1434CB'
                    },
                    buttonTypeStyleHover: {
                        borderWidth: 1,
                        borderColor: colorMapping[ColorTokens.Primary_100],
                        backgroundColor: '#FFF',
                    },
                    buttonTextStyleHover: {
                        color: '#1434CB'
                    },
                    buttonTypeStyleDisabled: {
                        backgroundColor: '#FFF',
                        borderWidth: 1,
                        borderColor: '#E4E7EC',
                    },
                    buttonTextStyleDisabled: {
                        color: '#667085',
                    },
                });
            case ButtonTypeDLS.TERTIARY:
                return StyleSheet.create({
                    buttonTypeStyleDefault: {},
                    buttonTextStyleDefault: {
                        color: '#1434CB'
                    },
                    buttonTypeStyleHover: {
                    // color: '#122FB7'
                    },
                    buttonTextStyleHover: {
                        color: '#122FB7'
                    },
                    buttonTypeStyleDisabled: {},
                    buttonTextStyleDisabled: {
                        color: '#667085'
                    }
                });
            default:
                return StyleSheet.create({
                    buttonTypeStyleDefault: {
                        backgroundColor: colorMapping[ColorTokens.Primary_100],
                    },
                    buttonTextStyleDefault: {
                        color: '#FFF'
                    },
                    buttonTypeStyleHover: {
                        backgroundColor: '#122FB7',
                    },
                    buttonTextStyleHover: {
                        color: '#FFF'
                    },
                    buttonTypeStyleDisabled: {
                        backgroundColor: '#F9FAFB',
                        borderWidth: 1,
                        borderColor: '#E4E7EC',
                    },
                    buttonTextStyleDisabled: {
                        color: '#667085',
                    },
                });
        }
    };
    const sizeDLSStyle = (sizeDLS) => {
        switch (sizeDLS) {
            case ButtonSizeDLS.LARGE:
                return StyleSheet.create({
                    buttonSizeDLS: {
                        // paddingVertical: 12,
                        height: 48,
                        paddingHorizontal: paddingHorizontalDC
                    }
                });
            case ButtonSizeDLS.MEDIUM:
                return StyleSheet.create({
                    buttonSizeDLS: {
                        // paddingVertical: 10,
                        height: 40,
                        paddingHorizontal: paddingHorizontalDC
                    }
                });
            case ButtonSizeDLS.SMALL:
                return StyleSheet.create({
                    buttonSizeDLS: {
                        // paddingVertical: 6,
                        height: 32,
                        paddingHorizontal: paddingHorizontalDC
                    }
                });
            default:
                // default is medium.
                return StyleSheet.create({
                    buttonSizeDLS: {
                        paddingVertical: 10,
                        paddingHorizontal: paddingHorizontalDC
                    }
                });
        }
    };
    const getButtonLabelColor = (typeDLS, isDisabled) => {
        if (isDisabled) {
            return ColorTokens.Grey_Charcoal;
        }
        else {
            switch (typeDLS) {
                case ButtonTypeDLS.PRIMARY:
                    return ColorTokens.Grey_Milk_1;
                case ButtonTypeDLS.SECONDARY:
                    return ColorTokens.Primary_100;
                case ButtonTypeDLS.TERTIARY:
                    return ColorTokens.Primary_100;
                default:
                    return ColorTokens.Grey_Milk_1;
            }
        }
    };
    const getButtonFontSize = (sizeDLS) => {
        switch (sizeDLS) {
            case ButtonSizeDLS.LARGE:
                return TypographyTypeDLS.B0B;
            case ButtonSizeDLS.MEDIUM:
                return TypographyTypeDLS.B1B;
            case ButtonSizeDLS.SMALL:
                return TypographyTypeDLS.B2B;
            default:
                return TypographyTypeDLS.B1B;
        }
    };
    const getButtonStyle = (typeDLS, isDisabled) => {
        if (isDisabled) {
            return typeDLSStyles(typeDLS).buttonTypeStyleDisabled;
        }
        else {
            if (isFocus) {
                return typeDLSStyles(typeDLS).buttonTypeStyleHover;
            }
            else {
                return typeDLSStyles(typeDLS).buttonTypeStyleDefault;
            }
        }
    };
    const _renderIcon = React.useMemo(() => !loading &&
        (iconName) && (React.createElement(View, { style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        } },
        React.createElement(Icon, { name: iconName, size: sizeDLS === ButtonSizeDLS.LARGE ?
                IconSizeTokens.XL :
                sizeDLS === ButtonSizeDLS.SMALL ?
                    IconSizeTokens.MD :
                    IconSizeTokens.LG, color: typeDLS === ButtonTypeDLS.PRIMARY ?
                ColorTokens.Grey_Milk :
                typeDLS === ButtonTypeDLS.TERTIARY ?
                    ColorTokens.Primary_100 :
                    ColorTokens.Primary_100 }))), [iconName]);
    return (React.createElement(Pressable, { style: [
            typeDLS &&
                getButtonStyle(typeDLS, isDisabled),
            sizeDLS &&
                sizeDLSStyle(sizeDLS).buttonSizeDLS,
            {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                borderRadius: isfromTDL ? 8 : 1000
            }
        ], onPress: () => {
            !loading &&
                !isDisabled &&
                onPress &&
                onPress();
        }, onHoverIn: () => {
            setIsFocus(true);
        }, onHoverOut: () => {
            setIsFocus(false);
        } },
        React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'row',
                alignContent: 'center',
                alignItems: 'center'
            } },
            React.createElement(Typography, { label: label, typeDLS: getButtonFontSize(sizeDLS), color: getButtonLabelColor(typeDLS, isDisabled) }),
            React.createElement(Space, { size: SizeTypeTokens.SM }),
            iconName &&
                _renderIcon,
            loading && (React.createElement(ActivityIndicator, { style: {
                    marginLeft: 8
                }, size: 16, animating: true, color: colorMapping[getButtonLabelColor(typeDLS)] })))));
};
export default memo(ButtonBaseDLS);
export { ButtonBaseDLS };
